import type {BioIconProps} from './common-types'

export function IconShareGray({...attributes}: BioIconProps) {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...attributes}>
      <path
        d="M13.3307 8.66667V12.6667C13.3307 13.0203 13.1903 13.3594 12.9402 13.6095C12.6902 13.8595 12.351 14 11.9974 14H3.9974C3.64377 14 3.30464 13.8595 3.05459 13.6095C2.80454 13.3594 2.66406 13.0203 2.66406 12.6667V8.66667M7.9974 10V2M7.9974 2L5.66406 4.33333M7.9974 2L10.3307 4.33333"
        stroke="black"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
